<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import type { Product, CartProduct } from "@shared/types/ProductLine";
  import { productContainerDetailsShort } from "@shared/filters/product_container_details.js";
  import ProductLineDetailsDeals from "@retailer/svelte/ProductDetails/Deals.svelte";
  import CartDealPopover from "@retailer/svelte/Cart/Page/CartDealPopover.svelte";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";

  export let product: Product;
  export let callbacks: any;
  export let productIsRequestable: boolean = false;
  export let usesFuturePricingWithMinBottle: boolean = false;

  let showDealPopover: boolean = false;
  let castCartProduct = (<unknown>product) as CartProduct;
  const showSkuOnPDP = stagedRolloutCheck("show_sku_on_pdp");
</script>

<div class="grid-col c12-12 margin-bottom--smaller">
  <div class="media fizz-styles">
    <div class="media-fluid" class:opacity-20={productIsRequestable}>
      {productContainerDetailsShort(product)}
      {#if product.packaging_description}
        <span>({callbacks.getEnglishDescription(product)})</span>
      {/if}
      {#if showSkuOnPDP && product.inventory && product.inventory.sku && product.inventory.sku != ""}
        <div class="fizz-text-small fizz-text-subdued">
          SKU: {product.inventory.sku}
        </div>
      {/if}
      {#if product?.permanent_deal_notes?.notes}
        <div
          class="brand-small--regular margin-bottom--smallest cursor-pointer preexisting-deal-note-button"
          on:click={() => (showDealPopover = true)}
        >
          <Icon type={"DealNote"} /> Permanent Deal Note
        </div>
      {/if}
      <div class="position-relative">
        <CartDealPopover
          show={showDealPopover}
          product={castCartProduct}
          saveCallback={callbacks.saveDeal}
        />
      </div>
    </div>
  </div>
</div>

{#if !usesFuturePricingWithMinBottle}
  <div data-testid="deals">
    <ProductLineDetailsDeals bind:product />
  </div>
{/if}
